import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronsDown } from "@fortawesome/pro-solid-svg-icons/faChevronsDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, Stack } from '@mui/material';
import { AppImageDimension } from "app/appImages";
import { MprcText } from "components";
import React from 'react';

interface IProps {
    message?: React.ReactNode;
    icon?: IconProp;
    marginWidth: number;
    height?: number | string;
    color?: MprcColors;
    onClick?: () => void;
}

export const MprcRibbonGenericCard = ({ message, marginWidth, height, color = "info", icon = faChevronsDown, onClick }: IProps) => {
    return (
        <Card sx={
            {
                minWidth: AppImageDimension.ThumbnailWide.width,
                mt: "6px",
                mr: `8px`,
                ml: `${marginWidth}px`,
                display: "flex",
                alignItems: " center",
                justifyContent: "center",
                boxShadow: "rgba(0,0,0,0.1) 2px 2px 8px 2px",
            }}
            elevation={1}
        >
            <Box
                sx={
                    {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItem: "center",
                        cursor: "pointer",
                        height: height ?? "inherit",
                        width: "100%"
                    }
                }
                onClick={onClick}
            >
                <Stack direction="column" alignItems="center" spacing={1} height="inherit" padding={1} >
                    <div style={{ height: "100%" }}>
                        <Stack direction="column" justifyContent="center" height="inherit">
                            <MprcText color={color}>
                                <FontAwesomeIcon icon={icon} size="6x" />
                            </MprcText>
                        </Stack>
                    </div>
                    <MprcText color={color}>
                        {message}
                    </MprcText>
                </Stack>
            </Box>
        </Card>
    );
};
